import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector/cjs';

export const languages = ['en', 'ar'];
export const defaultLang = languages[0];

i18next
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // lng: 'en', // if you're using a language detector, do not define the lng option
    // debug: true,
    supportedLngs: languages,
    fallbackLng: defaultLang,
    fallbackNS: 'common',
    defaultNS: 'common',
    nonExplicitSupportedLngs: true, // Handle both en-US and en
    ns: ['common', 'ui_common', 'currency_common', 'calendar_event'],
    interpolation: {
      escapeValue: false,
    },
    // disable cache
    backend: {
      requestOptions: {
        cache: 'no-store',
      },
    },
  });

export default i18next;
